// One citation id (`1101.4`): a 4-7 digit group and a 1-6 digit component.
// Every citation pattern in the app is built from it. A shorter bracketed
// decimal is the answer's own figure (`$[20.0] million`), never a citation
// (#12767). Kept free of imports so a node-environment test can load it.
export const CITATION_ID_PATTERN = String.raw`\d{4,7}\.\d{1,6}`;
